var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 16,
    viewBox: "0 0 68 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16_34",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 68,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67.3684,
    height: 16,
    fill: "url(#pattern0_16_34)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16_34)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -4,
    width: 80,
    height: 28,
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_16_34",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_16_34",
    transform: "scale(0.0125 0.0526316)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_16_34",
    width: 80,
    height: 19,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAATCAYAAAAH3YpvAAACFElEQVRYCe1Yy3HCMBClBDqIj2DtzriElJAS6CB0kHQQOqAESnAJPmYmwdaNq0sg8zQSLJLAKBgONswwrO310+7bn8RkcsePns2yLfNbrdRym+cLuRSuG+a2IdoHX+YW7/j6uPdL9PqT54V8NhgZpGil1g1RFSNnN5+/OGdBRkCcIFMSiECc0a000cYPjlujj99vrM3caqKPPvAMRpVl0y3zAuASNHCSWcNBkJripM6yqcSFjPdrpVaaqGyYtb+W1EeGIvN9+6TOtbIuiqldq62KIrDrKhwQhtLRSn2dGM+sJQCcBLE6z4sYCVL3Vhn4sAlr4lfimQo4ZnNVK7X2daR+l2yCRrSXVdH1zuG5jbjfq3BdpmTVAfABArLPOu3bDRLWqSaAfGQhMC++i0yTCiJ90ejLmujzlkhK7EfJsBd2uywCEbIU4bPvd8y2hsgEI+o/bqJX2cZfSQA08HuXo1zvnrLxxZvgrty7yhxBAPk10erERpBnm6TZTgQKJ9rDu4C/0n/075iXYicQDhNkn0lzr4RjQEO8B3LMlCfaXPLPtYF/DZNLwGN5huGEbO0cJmMhJNVPO1TPD5NUwDHqu545tlnRW6w10bsdOuEw6W2VgQFhn4izsMYZ/3jCeRLYFWe7Py4FadjqtWPesXRxNnHZFvk3qYyeQjoRR6LwzLYbAy3KFCW6eWZbIqHmJKLUMvXc/wdYk59BVfjeWAAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.31babdc309ba786175fdc8ed0248581e.svg";
export { ForwardRef as ReactComponent };